import React from "react";
import "./style.scss";
import { ReactComponent as IconMinus } from "../../assets/icons/minus.svg";
import { ReactComponent as IconPlus } from "../../assets/icons/plus.svg";

export interface CounterProps {
    value: number;
    onChange: (value: number) => void;
}

const Counter = ({value, onChange}: CounterProps) => {

    return <div className="Counter">
        <IconMinus className="minus" onClick={() => onChange(value - 1)} />
        <div className="count">
            {value}
        </div>
        <IconPlus className="plus" onClick={() => onChange(value + 1)} />
    </div>
}

export default Counter;